import { Dialog } from "@ark-ui/react";
import type { ComponentProps } from "react";

type Props = ComponentProps<typeof Dialog.Trigger>;

const Trigger = (props: Props) => <Dialog.Trigger {...props} />;

export default Trigger;
